module.exports = __webpack_public_path__ + "media/images/design/common/images/side_menu_li_bg2-5f7b902624a4e332fb6b55f0dff575c1.png";